<mat-card class="altair-card tickets-solved-and-cleated-card mb-25 border-radius bg-white border-none d-block">
    <mat-card-header>
        <mat-card-title>
            <h5 class="mt-0 mb-0">
                {{data.name}}
            </h5>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <apx-chart
            [series]="chartOptions.series!"
            [chart]="chartOptions.chart!"
            [xaxis]="chartOptions.xaxis!"
            [dataLabels]="chartOptions.dataLabels!"
            [grid]="chartOptions.grid!"
            [stroke]="chartOptions.stroke!"
            [yaxis]="chartOptions.yaxis!"
            [colors]="chartOptions.colors!"
            [legend]="chartOptions.legend!"
            [fill]="chartOptions.fill!"
        ></apx-chart>
    </mat-card-content>
</mat-card>
